import { Builder, withChildren } from '@builder.io/react';

import Banner from './index';

const BannerWithBuilderChildren = withChildren(Banner);

Builder.registerComponent(BannerWithBuilderChildren, {
  name: 'Banner',
  inputs: [
    {
      name: 'inverted',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'spacing',
      type: 'string ',
      defaultValue: 'sm',
      enum: ['sm', 'md']
    },
    {
      name: 'overtitle',
      type: 'string'
    },
    {
      name: 'title',
      type: 'longText',
      defaultValue: 'Scale'
    },
    {
      name: 'product',
      type: 'string'
    },
    {
      name: 'subtitle',
      type: 'longText'
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ],
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              variant: 'primary'
            }
          ]
        },
        {
          name: 'hubspotFormBanner',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotFormBanner',
          type: 'object',
          subFields: [
            {
              name: 'id',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            },
            {
              name: 'duplicateId',
              type: 'number'
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'boolean',
          defaultValue: false
        },
        {
          name: 'hubspotModal',
          type: 'object',
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'sfdcCampaignId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'Video'
      }
    }
  ]
});
